export class CalendarEvent {
  id: number = -1;
  title: string = '';
  date: string = '';
}
